import MetodoPagamentoModel from "../../models/financeiro/metodoPagamentoModel";

import { IService } from "./../base/iService";

export default class MetodoPagamentoService extends IService<MetodoPagamentoModel> {
    constructor() {
        super("MetodoPagamento");
    }
}